import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ALERTS, FormBuilder, FormGroup, Validators } from 'src/app/common';
import { AppConstants } from 'src/app/common/constants';
import { IPermission } from 'src/app/models';
import { AlertService, BlockUiHandlerService, PermissionService, StorageService } from 'src/app/services';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.css']
})
export class PermissionsComponent implements OnInit {
  //[VARBOX]
  permissions: IPermission[];
  permissionForm: FormGroup;
  modalReference: NgbModalRef;
  permission: IPermission;

  constructor(
    private alertService: AlertService, 
    private formBuilder: FormBuilder, 
    private modalService: NgbModal, 
    private permissionService: PermissionService, 
    private blockUiService: BlockUiHandlerService, 
    private storageService: StorageService
    ) { }

    ngOnInit(): void {
      this.InitVariables();
      this.LoadData();
    }
  
    InitVariables(): void {
      this.permissions = [];
      this.ResetPermissionForm();
    }
  
    LoadData(): void {
      this.GetPermissions();
    }

    GetPermissions(): void {
      this.blockUiService.Start(1);
      this.permissionService.Get().subscribe(next => {
        this.blockUiService.Stop();
        if (next.Result) {
          this.permissions = next.Permissions;
        }
        else {
          this.alertService.ShowSmallCornerAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.warning);
        }
      }, error => {
        this.blockUiService.Stop();
        this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
      });
    }

    StorePermission(): void {
      const PERMISSION = this.permissionForm.value as IPermission;
      if (!this.permissionForm.valid) {
        this.alertService.ShowSmallCornerAlert(`Todos los campos son requeridos`, ALERTS.info);
        return;
      }
  
      PERMISSION.Id === -1 ? this.CreatePermission(PERMISSION) : this.UpdatePermission(PERMISSION);
    }

    RaisePermissionModal(content, isUpdating: boolean = false, _isOnRole = false): void {
      if (!isUpdating) this.ResetPermissionForm();
      this.modalReference = this.modalService.open(content,
        {
          centered: true,
          backdrop: 'static'
        });
    }

    ResetPermissionForm(): void {
      this.permissionForm = this.formBuilder.group({
        Id: [-1],
        Name: ['', Validators.required],
        Code: ['', Validators.required],
        Type: ['', Validators.required],
        IsActive: [true, Validators.required]
      });
    }

    ClosePermissionModal(): void {
      this.modalReference.close();
    }

    GetPermission(_id: number, content): void {
      this.permissionService.GetPermission(_id).subscribe(next => {
        if (next.Result) {
          this.permission = next.Permission;
          this.permissionForm.patchValue({
            ...this.permission
          });
          this.RaisePermissionModal(content, true, true);
        }
        else {
          this.alertService.ShowSmallCornerAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.warning);
        }
      }, error => {
        this.blockUiService.Stop();
        this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
      });
    }
  
    GetPermissionType(_type: number): string {
      return AppConstants.GetPermissionType(_type);
    }
  
    CreatePermission(_permission: IPermission): void {
      this.blockUiService.Start(1, `Agregando permiso, espere por favor`);
      this.permissionService.StorePermission(_permission).subscribe(next => {
        this.blockUiService.Stop();
        if (next.Result) {
          this.alertService.ShowSmallCornerAlert(`Permiso agregado`, ALERTS.success);
          this.ClosePermissionModal();
          this.GetPermissions();
        }
        else {
          this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
        }
      }, error => {
        this.blockUiService.Stop();
        this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
      });
    }
  
    UpdatePermission(_permission: IPermission): void {
      this.blockUiService.Start(1, `Actualizando permiso, espere por favor`);
      this.permissionService.Put(_permission).subscribe(next => {
        this.blockUiService.Stop();
        if (next.Result) {
          this.alertService.ShowSmallCornerAlert(`Permiso actualizado`, ALERTS.success);
          this.ClosePermissionModal();
          this.GetPermissions();
        }
        else {
          this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
        }
      }, error => {
        this.blockUiService.Stop();
        this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
      });
    }

}
